namespace h5_vm {
   export enum VmWorkflowMode {
      CreateMode,
      UpdateMode,
      CloneMode,
      DeployVmtxMode
   }
}
